import {ApiTags, baseApi} from "../../../app/api/baseApi";
import {CmQueryResult} from "../../../app/types";
import {EmissionListItem, EmissionsFilteringMeta} from "../types";


export const emissionsApiSlice = baseApi.injectEndpoints({
    endpoints: builder => ({
        getEmissionsFiltersMeta: builder.query<CmQueryResult<EmissionsFilteringMeta>, void>({
            query: () => {
                return {
                    reducerPath: 'emissionsFiltersMeta',
                    url: `/api/v1/emissions/filters_meta`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 120
        }),
        getEmissions: builder.query<CmQueryResult<EmissionListItem[]>, string>({
            query: (query) => {
                return {
                    reducerPath: 'creations',
                    url: `/api/v1/emissions?${query}`,
                    method: 'GET',
                }
            },
            providesTags: (_) => [ApiTags.EmissionsList],
            keepUnusedDataFor: 5
        }),
        stopEmission: builder.mutation<any, number>({
            query: (emissionId: number): any => {
                return {
                    url: `/api/v1/emissions/${emissionId}/stop`,
                    method: 'POST',
                }
            },
            invalidatesTags: (_) => [ApiTags.EmissionsList],
        }),
        downloadEmissionFileUrl: builder.mutation<string, any>({
            query: (emissionId: number): any => {
                return {
                    url: `/api/v1/emissions/${emissionId}/generate_preview`,
                    method: "POST",
                    cache: "no-cache",
                }
            },
            transformResponse(response: any) {

                return response.data.emissionPreviewUrl;
            }
        }),
        // downloadEmission: builder.mutation<any, number>({
        //     query: (emissionId: number): any => {
        //         return {
        //             url: `/api/v1/emissions/${emissionId}/generate_preview`,
        //             method: "POST",
        //             cache: "no-cache",
        //         };
        //     },
        //     transformResponse(response: any) {
        //         const link = document.createElement('a')
        //         link.href = decodeURIComponent(response.data.emission_preview_url)
        //         link.download = response.data.name
        //         console.log(link)
        //         document.body.appendChild(link)
        //         link.click()
        //         document.body.removeChild(link)
        //         return response;
        //     }
        // }),
        resumeEmission: builder.mutation<any, number>({
            query: (emissionId: number): any => {
                return {
                    url: `/api/v1/emissions/${emissionId}/resume`,
                    method: 'POST',
                }
            },
            invalidatesTags: (_) => [ApiTags.EmissionsList],
        }),
    })
})

export const {
    useGetEmissionsFiltersMetaQuery,
    useGetEmissionsQuery,
    useStopEmissionMutation,
    useResumeEmissionMutation,
    useDownloadEmissionFileUrlMutation,
} = emissionsApiSlice